import styled from 'styled-components';

export const Sidebar = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 250px;
  height: 100vh;
  height: 100dvh;
  background: #30D5C8;
  color: white;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s ease;
  z-index: 1000;
  box-shadow: 4px 0 6px -1px rgba(0, 0, 0, 0.1);

  &.collapsed {
    width: 70px;
  }

  @media (max-width: 768px) {
    width: min(82vw, 300px);
    transform: translateX(-100%);
    transition: transform 0.3s ease, visibility 0.3s ease;
    visibility: hidden;
    box-shadow: 12px 0 32px rgba(15, 23, 42, 0.22);

    &.mobile-open {
      transform: translateX(0);
      visibility: visible;
    }

    &.collapsed {
      width: 250px;
    }
  }
`;

export const SidebarOverlay = styled.button`
  display: none;

  @media (max-width: 768px) {
    position: fixed;
    inset: 0;
    z-index: 999;
    display: block;
    border: 0;
    background: rgba(15, 23, 42, 0.48);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.25s ease, visibility 0.25s ease;

    &.visible {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }
  }
`;

export const MobileBottomNav = styled.nav`
  display: none;

  @media (max-width: 768px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1002;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(64px, 1fr);
    min-height: 66px;
    padding: 6px 6px max(6px, env(safe-area-inset-bottom));
    border-top: 1px solid #e2e8f0;
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.1);
    backdrop-filter: blur(14px);
  }
`;

export const MobileBottomItem = styled.button`
  min-width: 0;
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  padding: 5px 3px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #64748b;
  text-decoration: none;
  cursor: pointer;

  > span:first-child {
    width: auto;
    font-size: 20px;
    line-height: 1;
  }

  > span:last-child {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: inherit;
    font-size: 10px;
    font-weight: 700;
    white-space: nowrap;
  }

  &.active {
    background: #e8fbf9;
    color: #0f8f86;
  }
`;

export const MobileMoreOverlay = styled.button`
  display: none;

  @media (max-width: 768px) {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: block;
    border: 0;
    background: rgba(15, 23, 42, 0.48);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.25s ease, visibility 0.25s ease;

    &.visible {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }
  }
`;

export const MobileMoreSheet = styled.div`
  display: none;

  @media (max-width: 768px) {
    position: fixed;
    left: 0;
    right: 0;
    bottom: calc(66px + env(safe-area-inset-bottom));
    z-index: 1001;
    display: block;
    max-height: min(64dvh, 520px);
    overflow-y: auto;
    padding: 16px;
    border-radius: 20px 20px 0 0;
    background: #fff;
    box-shadow: 0 -16px 40px rgba(15, 23, 42, 0.18);
    transform: translateY(calc(100% + 90px));
    visibility: hidden;
    transition: transform 0.28s ease, visibility 0.28s ease;

    &.visible {
      transform: translateY(0);
      visibility: visible;
    }
  }
`;

export const MobileMoreHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  color: #0f172a;
  font-size: 18px;

  button {
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 50%;
    background: #f1f5f9;
    color: #334155;
    font-size: 24px;
    cursor: pointer;
  }
`;

export const MobileMoreGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
`;

export const MobileMoreItem = styled.button`
  min-width: 0;
  min-height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 7px;
  padding: 10px 6px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;

  &.active {
    border-color: #30d5c8;
    background: #e8fbf9;
    color: #0f766e;
  }

  > span:first-child {
    width: auto;
    font-size: 24px;
  }
`;

export const SidebarHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;

  @media (max-width: 768px) {
    min-height: 64px;
    padding: 12px 16px;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const LogoText = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;

  img {
    width: 120px;
    // filter:invert(1);
  }

`;

export const LogoIcon = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #60a5fa;
  background: rgba(96, 165, 250, 0.1);
  padding: 8px;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

`;

export const CollapseButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
  min-width: 40px;
  min-height: 40px;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const SidebarNav = styled.nav`
  flex: 1;
  min-height: 0;
  padding: 20px 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.55) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.45);
    border-radius: 999px;
  }
`;

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const NavItem = styled.li`
  margin-bottom: 4px;
`;

export const NavLink = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: #000;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  font-size: 14px;
  position: relative;

  @media (max-width: 768px) {
    min-height: 48px;
    padding: 13px 18px;
    font-size: 15px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }

  &.active {
    background: rgb(255 255 255 / 20%);
    color: #ffffff;
    border-right: 3px solid #60a5fa;
    font-weight: 700;
  }

  &.active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #60a5fa;
  }
`;

export const NavIcon = styled.span`
  font-size: 18px;
  width: 20px;
  text-align: center;
`;

export const NavLabel = styled.span`
  font-weight: 500;
`;

export const SidebarFooter = styled.div`
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const UserDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  background: rgba(96, 165, 250, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
`;

export const UserText = styled.div`
  flex: 1;
`;

export const UserName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: white;
`;

export const UserRole = styled.div`
  font-size: 12px;
  color: #94a3b8;
`;

export const UserAvatarCollapsed = styled.div`
  width: 40px;
  height: 40px;
  background: rgba(96, 165, 250, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin: 0 auto;
`;

// Collapsed sidebar styles
export const CollapsedNavLink = styled(NavLink)`
  justify-content: center;
  padding: 12px;
  position: relative;

  &[title]:hover::after {
    content: attr(title);
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    background: #1e293b;
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1001;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;
